import React, { useEffect, useRef } from 'react';
import './servicesClients.scss';

const ServicesClients = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  const colaboraciones = [
    { id: 1, nombre: 'Fundaciones Sociales' },
    { id: 2, nombre: 'Centros de Investigación' },
    { id: 3, nombre: 'Universidades' },
    { id: 4, nombre: 'Productoras Audiovisuales' },
    { id: 5, nombre: 'Servicios de Salud' },
    { id: 6, nombre: 'Instituciones Educativas' },
  ];

  return (
    <div className="services-clients">
      <section className="services-clients__section">
        <div className="services-clients__content">
          <h1 className="services-clients__title content__title-backgroundDark">
            Colaboraciones estratégicas
          </h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div className="services-clients__text">
            <p className="services-clients__text-paragraph content__text-title-backgroundDark">
              Creemos en el poder de las alianzas para transformar la industria
              audiovisual. Trabajamos junto a instituciones, centros de
              conocimiento y profesionales del sector comprometidos con la
              ciencia aplicada y el impacto real.
            </p>
          </div>
        </div>
        <div className="services-clients__content-clients">
          {colaboraciones.map((item) => (
            <div
              key={item.id}
              className="services-clients__content-container-text"
            >
              <span className="services-clients__nombre">{item.nombre}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServicesClients;
